import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import FormLink from '../../../../library/form/components/FormLink';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import FormImgPopup from '../../../../library/form/components/FormImgPopup'
import DocAdminInfo from '../../../cmn/DocAdminInfo';
import FormStatus from '../../../../library/form/components/FormStatus';

const ItemHeaderView = (props) => {
    const { formObject } = props;

    return (
        <div className="phViewArea" id="viewContainer">
            <div className="phViewHeading">
                <div className="phTitle">
                    <FormTitle formObject={formObject} value='Header' />
                </div>
                <div className="phAction uiFlexBox3">
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormLink formObject={formObject} rowKey="" text={<SarasTrans value="View BOM" />}
                        action={{
                            paramName: "bomLink",
                            actionId: "show", 
                            containerKey: "popup",
                            actionParam: { module: 'item', view: 'itembom' }
                        }}
                        linkProp={{ target: "_blank" }}
                        className="uiActionButton"
                    ></FormLink>
                    <FormButton formObject={formObject} ksc="c" rowKey="" className="uiActionIconButton"
                        starIcon={"variation"}
                        action={{ 
                            actionId: "new", paramName: "varianceActionButton", 
                            actionName: "itemComp", 
                            actionParam: {  "createChild": 1, 
                                            "showModeID": 'sh',
                                            "imdtId": '%dataList.imdtId', 
                                            "imdocId": '%dataList.imdocId',
                                            "positionID": '%dataList.positionID' 
                                         },
                            containerKey: "popup" 
                                }}
                        text={<SarasTrans value="Create Variance" />}>
                    </FormButton>
                    <FormButton formObject={formObject} ksc="h" rowKey="" starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                </div>
            </div>
            <div className="uiSingleColumn phViewContent">
                <div className="uiGridCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docId" }} />
                            </span>
                            <FormImgPopup formObject={formObject} rowKey="" action={{ paramName: "qrImage" }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docId" }} className="uiVal uiHighlightKey" />
                            
                            <FormWrapper customWrapper="" wrapperClass="" formObject={formObject} headerKey="docStatus" action={{ paramName: "docStatus" }}>
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} value="Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="docStatus"/>
                            </FormWrapper>
                            <FormLink formObject={formObject} rowKey="" className="uiLblInLine uiLink"
                                action={{ paramName: "parentId", actionId: "show",  containerKey: "popup" }}
                                linkProp={{ target: "_blank" }}
                            ></FormLink>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Item Name" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemName" }} className="uiVal" id="svItemName" />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nickName" }} className="uiVal" id="svNickName" />
                            
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCategory" }} value="Item Category 1" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemCategory" }} className="uiVal" id="svItemCategory" />
                            <FormWrapper customWrapper="span" formObject={formObject} rowKey="" action={{ paramName: "itemCategory2" }} >
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCategory2" }} value="Item Category 2" ID="vItemCategory2Lbl" className="uiLblInLine" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemCategory2" }} className="uiVal" id="svItemCategory2" />
                            </FormWrapper>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mainUnit" }} value=" Main Unit" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "mainUnit" }} className="uiVal" id="svMainUnit" />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "secondaryUnit" }} value="Second Unit" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "secondaryUnit" }} className="uiVal" id="svPackingUnit" />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isTrack" }} value="Track Inventory" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isTrack" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl" >
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCode" }} value="Item Code" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemCode" }} className="uiVal" id="svItemCode" />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refCode" }} value="Reference No" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refCode" }} className="uiVal" id="svRefCode" />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "urlShortCode" }} >
                            <span className="uiLbl" >
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "urlShortCode" }} value="QR Code" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "urlShortCode" }} className="uiVal" id="svUrlShortCode" />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "taxGroup" }} >
                            <span className="uiLbl" >
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxGroup" }} value="Tax Group" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taxGroup" }} className="uiVal"/>
                        </FormWrapper>
                        <li style={{ display: "none" }}>
                            <span>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "standardCost" }} value="Standard Cost" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "standardCost" }} className="uiVal" />
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currency" }} className="uiVal" />
                            </span>
                        </li>
                    </ul>
                </div>
                <div className="uiGridCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "minOrder" }} value="Min Order Qty" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "minOrder" }} className="uiVal" id="svMinOrder" />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "stdWeight" }} value="Weight" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "stdWeight" }} className="uiVal" id="svStdWeight" />
                        </li>
                        <FormWrapper customWrapper="" wrapperClass="" wrapperStyle={{}} 
                            formObject={formObject} rowKey="" action={{ paramName: "launchContainer" }} >
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "launchDate" }} value="Launch Date" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "launchDate" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "launchStage" }} value="Launch Stage" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "launchStage" }} className="uiVal"/>
                        </li>
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reorderLevel" }} value="Reorder Level" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "reorderLevel" }} className="uiVal" id="svReorderLevel" />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "leadTime" }} value="Lead Time (in Days)" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "leadTime" }} className="uiVal" id="svLeadTime" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortOrder" }} value="Sort No" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "sortOrder" }} className="uiVal" id="svSortOrder" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "describe" }} value="Description" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "describe" }} className="uiVal" id="svDescribe" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "descShort" }} value="Short Desc." />
                            </span>
                            <div className='uiFlexDistributed'>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "descShort" }} className="uiVal" id="svPromoShort" />

                                <FormButton formObject={formObject} ksc="d" rowKey=""
                                        action={{ actionName:"itemPromo", actionId: "edit",  actionParam: {sview:'itemPromo'}, containerKey: "popup" }}
                                        className="uiActionButton" text={<SarasTrans value="Edit Desc." />} />
                            </div>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "descLong" }} value="Long Desc." />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "descLong" }} className="uiVal" id="svPromoLong" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "remarks" }} className="uiVal" id="svDescribe" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "keywords" }} value="Keywords" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "keywords" }} className="uiVal" id="svDescribe" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default withView(ItemHeaderView, "itemHeader", "")